<template>
  <div
    class="ma-1"
    align="center"
    justify="center"
    style="min-width: 200px; width: 200px; position: relative; cursor: pointer"
    :style="(chosenSubPlan && subPlan.id != chosenSubPlan.id) || disabledPlan ? 'opacity: 0.2' : ''"
    :class="!disabledPlan && chosenSubPlan && subPlan.id == chosenSubPlan.id ? 'elevation-20 chosenplan' : ''"
  >
    <img :src="subPlanImg" width="200px" style="min-width: 200px" />
    <div class="ma-0 pa-0" justify="center" align="center" style="position: absolute; left: auto; right: 36px; top: 40px; z-index: 10">
      <span class="ma-0 pa-0" style="font-size: 30px; color: white; white-space: pre-line">{{ subPlan.name }}</span>
    </div>
    <div style="position: absolute; left: 0; right: 0; top: 33%; z-index: 10">
      <p class style="color: rgb(0, 46, 110); white-space: pre-line">{{ subPlan.description }}</p>
    </div>
    <div style="position: absolute; left: 0; right: 0; top: auto; bottom: 10px; z-index: 10">
      <p class style="color: white; white-space: pre-wrap">{{ TR.PriceWithVat + " (" + TR.Month + ")\n" + subPlan.price.toFixed(2) + " " + TR.MoneyAbbreviation + "\n" + toEuro(subPlan.price).toFixed(2) + " " + TR.MoneyAbbreviation2 }}</p>
    </div>
  </div>
</template>
<script>
import { TR } from "../../main";
const planE = require(`@/assets/img/landing/Cards/Subscription_Plan_Empty.png`);

export default {
  props: {
    subPlan: {
      type: Object,
      default: null,
    },
    chosenSubPlan: {
      type: Object,
      default: null,
    },
    disabledPlan: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subPlanImg: planE,
      TR: TR,
    };
  },
  mounted() {
    // console.log(this.chosenSubPlan);
  },
};
</script>

<style>
.chosenplan {
  -webkit-border-radius: 22px 0px 22px 0px;
  -moz-border-radius: 22px 0px 22px 0px;
  border-radius: 22px 0px 22px 0px;
}
</style>